import { render, staticRenderFns } from "./Moneylog.vue?vue&type=template&id=4b3974ef&scoped=true&"
import script from "./Moneylog.vue?vue&type=script&lang=js&"
export * from "./Moneylog.vue?vue&type=script&lang=js&"
import style0 from "./Moneylog.vue?vue&type=style&index=0&id=4b3974ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3974ef",
  null
  
)

export default component.exports